/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
//actions
import { resetForm } from 'state/actions/shared_form_actions';
import { discardChanges } from 'state/actions/shared_form_actions';
import { savePaymentInformationWithValidation, updatePaymentInformationWithValidation, getPaymentInformation } from 'state/actions/accountState/account_data';

import { displayModal } from 'state/actions/modal_status';
import PaymentInfoCTAs from 'pages/dashboard/account/paymentinfo/paymentInfoCTAs/paymentInfoCTAs';




/* ========== ~~~~~~~~~~ PaymentINfo : PARENT ~~~~~~~~~~ ========== */

// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ accountData, sessionStatus, appStatus }) => ({

    fields: accountData.selectedPaymentType === 'NONE' ? null : accountData[accountData.selectedPaymentType].fields,
    savingData: accountData.selectedPaymentType === 'NONE' ? null : accountData[accountData.selectedPaymentType].savingData,
    editable: accountData.selectedPaymentType === 'NONE' ? null : accountData[accountData.selectedPaymentType].editable,
    hasStoredData: accountData.selectedPaymentType === 'NONE' ? null : Object.keys(accountData[accountData.selectedPaymentType].storedData).length > 0,
    formName: accountData.selectedPaymentType,
    paymentInfoReceived: accountData.paymentInfoReceived,
    selectedPaymentType: accountData.selectedPaymentType,
    paymentInfo: accountData.paymentInfo,
    payoutThreshold: accountData.payoutThreshold,
    savedPaymentInfo: accountData.paymentInfo.length > 0,
    preferredPaymentUpdated: accountData.preferredPaymentUpdated,
    paymentUUID: accountData.paymentUUID,
    accountUUID: sessionStatus.accountUUID,
    paymentInfoPermitted: sessionStatus.mocked || sessionStatus.permissions.includes('settings.paymentInfo'),
    mocked: sessionStatus.mocked,
    permissions: sessionStatus.permissions,
    currentPage: appStatus.currentPage,
    previousPage: appStatus.previousPage
});

// map actions
const mapDispatchToProps = dispatch => ({
    resetForm: formName => dispatch(resetForm(formName)),
    discardChanges: (formName) => dispatch(discardChanges(formName)),
    updatePaymentInformationWithValidation: ( data, paymentType, fields, paymentUUID, successAction ) => dispatch(updatePaymentInformationWithValidation(fields, data, paymentType, paymentUUID, successAction)),
    savePaymentInformationWithValidation: ( data, paymentType, fields, accountUUID, successAction ) => dispatch(savePaymentInformationWithValidation(fields, data, paymentType, accountUUID, successAction)),
    getPaymentInformation: (accountUUID) => dispatch(getPaymentInformation(accountUUID)),
    displayModal: (isVisible, contentToDisplay, showCloseButton) => dispatch(displayModal(isVisible, contentToDisplay, showCloseButton))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PaymentInfoCTAs);